<template>
  <!-- Image media -->
  <slot name="image" v-if="mediaType.includes('image')">
    <img :src="src ?? ''" alt="" />
  </slot>

  <!-- Video media -->
  <slot name="video" v-else-if="mediaType.includes('video')">
    <video controls>
      <source :src="src ?? ''" :type="mediaType" />
    </video>
  </slot>

  <!-- Google drive links -->
  <slot name="google-drive" v-else-if="mediaType.includes('Google drive')">
    <a :href="src ?? ''" target="_blank">
      <div class="default-media">
        <w-button expanded light large>
          <iconify-icon icon="logos:google-drive" />
          Open link
        </w-button>
      </div>
    </a>
  </slot>

  <!-- Youtube links -->
  <slot name="youtube" v-else-if="mediaType.includes('Youtube')">
    <a :href="src ?? ''" target="_blank">
      <div class="default-media">
        <w-button expanded light large><iconify-icon icon="logos:youtube-icon" /></w-button>
      </div>
    </a>
  </slot>

  <!-- Everything else -->
  <slot name="null" v-else-if="mediaType === 'null'">
    <div class="flex flex-col items-center justify-center p-4">
      <iconify-icon icon="fa6-solid:link-slash" />
    </div>
  </slot>
  <slot name="default" v-else>
    <a :href="src ?? ''" target="_blank">
      <div class="default-media">
        <p class="small">
          Media type :
          <span class="semi-bold">{{ mediaType }}</span>
        </p>
        <w-button expanded light>Open in new tab</w-button>
      </div>
    </a>
  </slot>
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  import mime from 'mime';

  export default {
    name: 'WMedia',
    props: {
      src: {
        type: String as PropType<string | undefined | null>,
        default: null,
      },
    },
    computed: {
      mediaType() {
        if (!this.src) return 'null';

        if (this.src.startsWith('https://drive.google.com')) return 'Google drive link';
        if (this.src.startsWith('https://youtu.be')) return 'Youtube';

        if (this.src) {
          const url = this.src?.split(/[#?]/)[0];
          return mime.getType(url) ?? 'unknown';
        }
        return 'unknown';
      },
    },
  };
</script>

<style lang="scss">
  @import '@/assets/styles/variables';

  img,
  video {
    width: 100%;
    height: fit-content;
  }

  img {
    height: fit-content;
    max-height: 100%;
    max-width: 100%;
    object-fit: cover;
  }

  video {
    height: fit-content;
  }

  .default-media {
    display: grid;
    gap: 0.5rem;
    padding: 0.5rem;
    border: 2px dotted $input-border;
    background-color: $white;
    border-radius: 1rem;
    margin: 0.5rem;
    transition: border-color ease 0.5s;

    &:hover {
      border-color: $primary-main;
    }
  }
</style>
